/**
 * Formato wa.me: solo cifre, prefisso internazionale incluso (senza +).
 * @param {string} phone - numero locale o già internazionale
 * @param {string} [countryCode] - prefisso nazionale senza + (default 39)
 * @returns {string|null}
 */
export function formatPhoneForWhatsApp(phone, countryCode) {
  if (!phone) return null;

  let prefix = String(countryCode || '39').replace(/\D/g, '');
  if (!prefix) prefix = '39';

  let digits = String(phone).replace(/[\s\-()]/g, '');
  if (digits.startsWith('+')) digits = digits.slice(1);
  else if (digits.startsWith('00')) digits = digits.slice(2);

  digits = digits.replace(/\D/g, '');
  if (!digits) return null;

  if (digits.startsWith(prefix)) {
    const local = digits.slice(prefix.length);
    const normalizedLocal = local.startsWith('0') ? local.slice(1) : local;
    return prefix + normalizedLocal;
  }

  if (digits.startsWith('0')) digits = digits.slice(1);

  return prefix + digits;
}

export function openWhatsAppChat(phone, countryCode) {
  const cleanPhone = formatPhoneForWhatsApp(phone, countryCode);
  if (!cleanPhone) return null;
  const url = `https://wa.me/${cleanPhone}`;
  window.open(url, '_blank');
  return url;
}
